module.exports = __webpack_public_path__ + "img/xzgz.a1335743.jpg";